module.exports = __webpack_public_path__ + "static/media/AU 2019 Research Roster - Idea Exchange.e85f3091.csv";